let lastTickMinutes = null;
let lastTimeFormat = null;
const tickClocks = (format = null) => {
    const now = moment();
    const minutes = parseInt(now.format("mm"));

    const timezoneNames = moment.tz.names();

    if (lastTickMinutes !== minutes || format !== lastTimeFormat) {
        for (const ianaTimezone of timezoneNames) {
            const dateWithTimezone = now.tz(ianaTimezone);
            let dateElements = document.querySelectorAll(`span[data-iana="${ianaTimezone}"]`);

            if ('useOffsets' in jinjaVars && dateElements.length === 0) {
                let offset = dateWithTimezone.utcOffset() * 60;
                dateElements = document.querySelectorAll(`span[data-iana="${offset}"]`);
            }

            const dateObject = dateWithTimezone;
            const day = dateObject.format("ddd");
            let time;

            if (format) {
                if (format === 24) {
                    time = dateObject.format("HH:mm");
                } else if (format === 12) {
                    time = dateObject.format("H:mm A");
                }
            } else {
                time = dateObject.format("LT");
            }

            const dateString = `${day} ${time}`;

            for (const element of dateElements) {
                element.innerHTML = dateString;
            }
        }

        lastTickMinutes = minutes;
        lastTimeFormat = format;
    }
}

const startClocks = () => {
    const defaultTimeFormat = getTimeFormat();
    const milliseconds = 1000;

    tickClocks(defaultTimeFormat);
    let tickInterval = setInterval(() => tickClocks(defaultTimeFormat), milliseconds);

    jinjaVars.timeFormatCallback = timeFormat => {
        clearInterval(tickInterval);
        tickClocks(timeFormat);
        tickInterval = setInterval(() => tickClocks(timeFormat), milliseconds);
    };
}

startClocks();
